module.exports = __webpack_public_path__ + "img/step2b.a3896c8f.jpg";